import { makeStyles } from '@material-ui/styles'

import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(4),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(4),
    width: '100%',
    marginBottom: spacing(4),
  },
  textInput: {
    '& .MuiOutlinedInput-root': {
      height: '40px',
      minWidth: '200px',
    },
  },
  label: {
    fontSize: spacing(14),
    color: Theme.Colors.Grayscale.Eighty,
  },
  removeButton: {
    height: '44px',
    width: '44px',
    padding: '10px',
    alignSelf: 'center',
  },
  errorMessage: {
    color: `${palette.error.main} !important`,
    margin: 0,
    fontFamily: 'Roboto',
    fontSize: spacing(10.5),
    height: spacing(14),
    display: 'flex !important',
  },
  numberInput: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '56px',
    fontSize: '14px',
    fontWeight: '500',
  },
}))
